// src/components/shared/SpotIndicator.jsx
// Indicador discreto de fila de spots para a sidebar.

import React, { useEffect, useState } from 'react';

function getSpotLabel(spot, index) {
  return (
    spot?.nome ||
    spot?.titulo ||
    spot?.texto ||
    spot?.text ||
    spot?.audioFile ||
    spot?.audioUrl ||
    spot?.id ||
    `Spot ${index + 1}`
  );
}

export default function SpotIndicator({ spotQueue = [], clearQueue, collapsed }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const temSpots = spotQueue.length > 0;
  const canExpand = temSpots && !collapsed;

  useEffect(() => {
    if (!temSpots || collapsed) setIsExpanded(false);
  }, [temSpots, collapsed]);

  return (
    <div>
      <div
        title={temSpots ? `${spotQueue.length} spot(s) na fila` : 'Fila de spots vazia'}
        onClick={() => canExpand && setIsExpanded(prev => !prev)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: collapsed ? 0 : '8px',
          padding: collapsed ? '8px 0' : '6px 12px',
          justifyContent: collapsed ? 'center' : 'flex-start',
          cursor: canExpand ? 'pointer' : 'default',
          userSelect: 'none',
          position: 'relative',
        }}
      >
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: temSpots
              ? 'rgba(251, 191, 36, 0.85)'
              : 'rgba(74, 222, 128, 0.85)',
            boxShadow: temSpots
              ? '0 0 6px rgba(251, 191, 36, 0.5)'
              : '0 0 6px rgba(74, 222, 128, 0.5)',
            transition: 'background 0.4s, box-shadow 0.4s',
          }} />

          {temSpots && (
            <div style={{
              position: 'absolute',
              top: '-6px',
              right: '-8px',
              background: 'linear-gradient(135deg, var(--error), #9b1a1a)',
              color: 'white',
              fontSize: '9px',
              fontWeight: 'bold',
              padding: '1px 4px',
              borderRadius: '8px',
              minWidth: '14px',
              textAlign: 'center',
              lineHeight: '14px',
            }}>
              {spotQueue.length}
            </div>
          )}
        </div>

        {!collapsed && (
          <span style={{
            fontSize: '12px',
            color: 'rgba(148, 163, 184, 0.7)',
            fontWeight: 500,
            letterSpacing: '0.05em',
          }}>
            SPT
          </span>
        )}
      </div>

      {isExpanded && temSpots && !collapsed && (
        <div style={{
          margin: '4px 8px 10px',
          background: 'rgba(var(--neutral-400-rgb), 0.98)',
          backdropFilter: 'blur(20px)',
          padding: '12px',
          borderRadius: '10px',
          border: '1px solid rgba(var(--brand-rgb), 0.3)',
          boxShadow: 'none',
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '10px',
          }}>
            <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--brand-400)' }}>
              Fila de Spots ({spotQueue.length})
            </span>
            <button
              onClick={(event) => {
                event.stopPropagation();
                clearQueue?.();
                setIsExpanded(false);
              }}
              style={{
                background: 'rgba(var(--error-rgb), 0.2)',
                border: '1px solid rgba(var(--error-rgb), 0.3)',
                color: 'var(--error)',
                padding: '4px 8px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '11px',
                flexShrink: 0,
              }}
            >
              Limpar
            </button>
          </div>

          <div style={{
            maxHeight: '180px',
            overflowY: 'auto',
            paddingRight: '2px',
          }}>
            {spotQueue.map((spot, index) => {
              const label = getSpotLabel(spot, index);
              return (
                <div
                  key={spot?.id || `${label}-${index}`}
                  title={label}
                  style={{
                    fontSize: '11px',
                    padding: '6px 8px',
                    background: 'rgba(var(--neutral-300-rgb), 0.5)',
                    borderRadius: '6px',
                    marginBottom: '4px',
                    color: 'var(--text-muted)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {index + 1}. {label}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
